import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'mx-nothing',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NothingComponent {
}
